import { WalletTransactionRefModel } from '../../../shared/models/wallet.model';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { Component, OnInit, inject } from '@angular/core';

@Component({
	selector: 'app-transaction-detail',
	templateUrl: './transaction-detail.component.html',
	styleUrls: ['./transaction-detail.component.scss']
})
export class TransactionDetailComponent implements OnInit {
	data: WalletTransactionRefModel;
	meterToken: string;
	token: string;
	readonly nzModalData = inject(NZ_MODAL_DATA, { optional: true }) ?? {};

	constructor(public modal: NzModalRef) { }

	ngOnInit(): void {
		this.modal.componentInstance = { ...this.modal.componentInstance, ...this.nzModalData };
		this.data = this.modal.componentInstance.data;
		if (this.data?.transaction?.billPaymentResponseAdditionalInfo) {
			let billPaymentResponseAdditionalInfo = this.data?.transaction?.billPaymentResponseAdditionalInfo;
			billPaymentResponseAdditionalInfo = billPaymentResponseAdditionalInfo.replace('\\', '');
			const indexI = billPaymentResponseAdditionalInfo.indexOf(':');
			const endIndexI = billPaymentResponseAdditionalInfo.indexOf(',');
			const indexII = billPaymentResponseAdditionalInfo.indexOf(':');
			const endIndexII = billPaymentResponseAdditionalInfo.lastIndexOf(',');
			this.meterToken = billPaymentResponseAdditionalInfo.substring(indexI + 2, endIndexI - 1);
			this.token = billPaymentResponseAdditionalInfo.substring(indexII + 2, endIndexII - 1);
		}
	}

}
